var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "numeric-stepper" },
    [
      _c("el-input", {
        attrs: { disabled: _vm.nsDisabled, type: "number" },
        on: { change: _vm.onChange },
        model: {
          value: _vm.ns,
          callback: function($$v) {
            _vm.ns = $$v
          },
          expression: "ns"
        }
      }),
      _vm.showTact
        ? _c("el-checkbox", {
            staticStyle: { "margin-left": "10px" },
            attrs: { disabled: _vm.tactDisabled, label: "TACT" },
            model: {
              value: _vm.tact,
              callback: function($$v) {
                _vm.tact = $$v
              },
              expression: "tact"
            }
          })
        : _vm._e(),
      _c("el-checkbox", {
        staticStyle: { "margin-left": "10px" },
        attrs: { label: _vm.nilLabel, disabled: _vm.nilDisabled },
        model: {
          value: _vm.nil,
          callback: function($$v) {
            _vm.nil = $$v
          },
          expression: "nil"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }